/**
 * Product ADA compatibility fixes
 * This script addresses specific accessibility issues on product pages
 */

document.addEventListener('DOMContentLoaded', function() {
  // Fix modal subheadline hierarchy
  fixModalSubheadlineHierarchy();
  
  // Fix Okendo review buttons with incorrect role
  fixOkendoButtonRoles();
  
  // Set up observer to catch dynamically loaded content
  setupMutationObserver();
});

/**
 * Fix modal subheadline hierarchy - changes h4 to h3 in modal subheadlines
 */
function fixModalSubheadlineHierarchy() {
  // Target the specific element by ID
  const subheadline = document.getElementById('aca-modal-subheadline');
  
  if (subheadline && subheadline.tagName === 'H4') {
    // Create a new h3 element with the same content and attributes
    const h3 = document.createElement('h3');
    h3.id = 'aca-modal-subheadline';
    h3.innerHTML = subheadline.innerHTML;
    h3.className = subheadline.className;
    
    // Copy any other attributes
    Array.from(subheadline.attributes).forEach(attr => {
      if (attr.name !== 'id') { // ID is already set
        h3.setAttribute(attr.name, attr.value);
      }
    });
    
    // Replace the h4 with the h3
    if (subheadline.parentNode) {
      subheadline.parentNode.replaceChild(h3, subheadline);
    }
  }
}

/**
 * Fix Okendo review buttons with incorrect role attribute
 */
function fixOkendoButtonRoles() {
  // Target Okendo media link buttons that have redundant role="button"
  const okendoButtons = document.querySelectorAll('.oke-media-link[role="button"]');
  
  okendoButtons.forEach(button => {
    // Remove the redundant role attribute
    button.removeAttribute('role');
  });
}



/**
 * Set up MutationObserver to watch for dynamically added elements
 */
function setupMutationObserver() {
  // Create a new observer
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Check for newly added modal subheadlines
        const modalSubheadline = document.getElementById('aca-modal-subheadline');
        if (modalSubheadline && modalSubheadline.tagName === 'H4') {
          fixModalSubheadlineHierarchy();
        }
        
        // Check for newly added Okendo buttons
        const newOkendoButtons = document.querySelectorAll('.oke-media-link[role="button"]');
        if (newOkendoButtons.length > 0) {
          fixOkendoButtonRoles();
        }
      }
    });
  });
  
  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}